import logo from "assets/images/dark_logo.png";
import PaddingX from "layouts/PaddingX";
import { NavLink, useLocation, Link } from "react-router-dom";
import useAuthStore from "store/authStore";
import useLogout from "api/UserResource/useLogout";
import Cart from "./Cart/Cart";
import CurrencyConverter from "./CurrencyConverter";
import MobileMenu from "./MobileMenu";
import ProfileIcon from "./ProfileIcon";
import useNavigationLinks from "./useNavigationLinks";
import NotificationBell from "components/NotificationBell";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { BiPowerOff } from "react-icons/bi";

const Header = () => {
	const logoWidth = 80;
	const { pathname } = useLocation();
	const isAuthenticated = useAuthStore((state) => state.loggedIn);

	const menu = useNavigationLinks();

	const { mutateAsync, isLoading } = useLogout();
	const handleLogout = async () => {
		await mutateAsync();
	};

	return (
		<div
			className={`sticky top-0 bg-white`}
			style={{
				zIndex: 999,
			}}
		>
			<div className="block lg:hidden py-2">
				<PaddingX>
					<MobileMenu isAuthenticated={isAuthenticated}>
						<CurrencyConverter />
						{isAuthenticated && <ProfileIcon />}
						<NotificationBell isAuthenticated={isAuthenticated} />
						<Cart />
					</MobileMenu>
				</PaddingX>
			</div>

			<div className="hidden lg:block">
				<PaddingX>
					<div className="grid grid-cols-12 justify-between py-2 gap-2 w-full">
						<div className="flex items-center col-span-2 pr-2 xs:pr-0 ">
							<NavLink to="/">
								<img src={logo} alt="Akello Library" width={logoWidth} />
							</NavLink>
						</div>

						<div className="flex items-center justify-center py-2 gap-2 col-span-8 ">
							{menu.map((item) => {
								let isActive = false;
								if (item.to.startsWith("/my-library")) {
									isActive = pathname === "/my-library";
								} else {
									isActive = pathname === item.to;
								}

								return (
									<Link
										key={item.to}
										to={item.to}
										label={item.label}
										className={`px-2 py-1 ${
											isActive
												? "rounded-full bg-gradient-to-r from-akgreen to-akgreenest text-white"
												: ""
										}`}
									>
										{item.label}
									</Link>
								);
							})}

							{/* <div className={`px-2 `}>
								<Search />
							</div> */}
						</div>

						<div className="flex items-center justify-end py-2 gap-2 col-span-2">
							<div>
								<CurrencyConverter />
							</div>
							{isAuthenticated && (
								<>
									<div className="flex items-center justify-center">
										<ProfileIcon />
									</div>
								</>
							)}
							<NotificationBell isAuthenticated={isAuthenticated} />
							<div className="pr-1">
								<Cart />
							</div>

							{isAuthenticated && (
								<button
									type="button"
									onClick={handleLogout}
									disabled={isLoading}
									title="Logout"
									aria-label="Logout"
									className="flex items-center gap-1 text-akgreenest hover:text-akgreener transition-colors disabled:opacity-50 shrink-0"
								>
									{isLoading ? (
										<AiOutlineLoading3Quarters size={30} className="animate-spin" />
									) : (
										<BiPowerOff size={30} />
									)}
								</button>
							)}
						</div>
					</div>
				</PaddingX>
			</div>
		</div>
	);
};

export default Header;
